// extracted by mini-css-extract-plugin
export var container = "_dn-0";
export var containerTopRight = "_dn-1";